<template>
  <v-container>
    <v-row justify="center" align="center" class="mt-10" v-if="loading">
      <v-progress-circular :size="70" color="#5c648b" indeterminate />
    </v-row>
    <v-col v-else>
      <v-col class="toggle-text mt-6">
        Are you a Parent or a Professional?
      </v-col>
      <v-row class="ma-0">
        <v-card
          class="pa-3 me-md-3"
          width="256px"
          :color="isProfessional ? '#506CFF' : '#FFFFFF'"
          @click="isProfessional = true"
        >
          <v-card-text align="center">
            <v-img
              max-width="140px"
              aspect-ratio="1"
              src="@/assets/professional.svg"
            />
            <div
              :class="
                isProfessional ? 'toggle-text white--text' : 'toggle-text'
              "
            >
              Professional
            </div>
          </v-card-text>
        </v-card>

        <v-card
          class="pa-3 ms-md-6 mt-6 mt-md-0"
          width="256px"
          :color="!isProfessional ? '#506CFF' : '#FFFFFF'"
          @click="isProfessional = false"
        >
          <v-card-text align="center">
            <v-img
              max-width="140px"
              aspect-ratio="1"
              src="@/assets/parent.svg"
            />
            <div
              :class="
                !isProfessional ? 'toggle-text white--text' : 'toggle-text '
              "
            >
              Parent
            </div>
          </v-card-text>
        </v-card>
      </v-row>
      <div class="preferences">
        <v-col
          align="left"
          v-for="(item, index) in isProfessional
            ? itemsForProfessional
            : itemsForParents"
          :key="index"
        >
          <div class="preference-heading">{{ item.name }}:</div>
          <v-row class="ma-0">
            <div
              v-for="(tag, index) in item.list"
              :class="
                tag.selected
                  ? 'ma-1 py-1 px-4 option-active'
                  : 'ma-1 py-1 px-4 option'
              "
              :key="index"
              @click="toggleSelected(tag, item)"
            >
              {{ tag.name }}
            </div>
          </v-row>
        </v-col>
      </div>

      <v-btn
        color="#506CFF"
        dark
        exact
        :loading="loadingSubmit"
        class="btn-text mt-8"
        @click="submitPreferences"
      >
        Save Details
      </v-btn>
    </v-col>
  </v-container>
</template>

<script>
  import Axios from "../../api/BaseAxios";
  import { API_COMMON_URL, ROUTER_URL } from "../../constants/urls";
  import AmplitudeHelper from "../../amplitude";

  export default {
    name: "EditPreferences",
    components: {},
    data() {
      return {
        isProfessional: true,
        loading: true,
        loadingSubmit: false,
        experiance_list: null,
        age_group_list: null,
        skill_list: null,
        tag_list: null,
        occupation_list: null,
        certification_list: null,
        school_type_list: null,
      };
    },
    created() {
      this.getPageDetails();
    },
    computed: {
      allItems() {
        return [
          {
            name: "Your years of experience",
            isProfessional: true,
            isParent: false,
            isSingle: true,
            list: this.experiance_list,
          },
          {
            name: "Age group you’re interested in",
            isProfessional: true,
            isParent: true,
            isSingle: false,
            list: this.age_group_list,
          },
          {
            name: "Skills",
            isProfessional: true,
            isParent: true,
            isSingle: false,
            list: this.skill_list,
          },
          {
            name: "Tags",
            isProfessional: true,
            isParent: true,
            isSingle: false,
            list: this.tag_list,
          },
          {
            name: "Your work settings",
            isProfessional: true,
            isParent: false,
            isSingle: true,
            list: this.occupation_list,
          },
          {
            name: "Your certifications",
            isProfessional: true,
            isParent: false,
            isSingle: false,
            list: this.certification_list,
          },
          {
            name: "Type of school your child studies in",
            isProfessional: false,
            isParent: true,
            isSingle: true,
            list: this.school_type_list,
          },
        ];
      },
      itemsForParents() {
        return this.allItems.filter(function(item) {
          return item.isParent;
        });
      },
      itemsForProfessional() {
        return this.allItems.filter(function(item) {
          return item.isProfessional;
        });
      },
    },
    watch: {},
    methods: {
      getPageDetails() {
        var self = this;
        const successHandler = (res) => {
          self.experiance_list = res.data.experience_list;
          self.age_group_list = res.data.age_group_list;
          self.skill_list = res.data.skills_list;
          self.tag_list = res.data.tags_list;
          self.occupation_list = res.data.occupation_list;
          self.certification_list = res.data.certification_list;
          self.school_type_list = res.data.school_type_list;

          self.isProfessional = res.data.data.certification_details.length != 0;

          self.age_group_list.forEach((element) => {
            if (
              res.data.data.interested_age_groups_details.filter(
                (e) => e.id === element.id
              ).length > 0
            ) {
              element.selected = true;
            }
          });

          self.skill_list.forEach((element) => {
            if (
              res.data.data.interested_skills_details.filter(
                (e) => e.id === element.id
              ).length > 0
            ) {
              element.selected = true;
            }
          });

          self.tag_list.forEach((element) => {
            if (
              res.data.data.interested_tags_details.filter(
                (e) => e.id === element.id
              ).length > 0
            ) {
              element.selected = true;
            }
          });

          self.experiance_list.forEach((element) => {
            if (res.data.data.user_experience_details.id == element.id) {
              element.selected = true;
            }
          });

          self.occupation_list.forEach((element) => {
            if (res.data.data.occupation_details.id == element.id) {
              element.selected = true;
            }
          });

          self.certification_list.forEach((element) => {
            if (
              res.data.data.certification_details.filter(
                (e) => e.id === element.id
              ).length > 0
            ) {
              element.selected = true;
            }
          });

          self.school_type_list.forEach((element) => {
            if (res.data.data.child_school_type_details.id == element.id) {
              element.selected = true;
            }
          });

          self.loading = false;
        };

        const failureHandler = (res) => {
          console.log(res);
          self.loading = false;
        };

        Axios.request_GET(
          API_COMMON_URL.userPreferences,
          {},
          {},
          successHandler,
          failureHandler,
          false
        );
      },
      containsObject(obj, list) {
        list.forEach((element) => {
          if (element === obj) {
            return true;
          }
        });
        return false;
      },
      toggleSelected(obj, item) {
        if (item.isSingle) {
          item.list.forEach((element) => {
            if (obj.id == element.id) {
              if (obj.selected) {
                obj.selected = false;
              } else {
                obj.selected = true;
              }
            } else {
              element.selected = false;
            }
          });
        } else {
          if (obj.selected) {
            obj.selected = false;
          } else {
            obj.selected = true;
          }
        }

        this.isProfessional = !this.isProfessional;
        this.isProfessional = !this.isProfessional;
        // this.$forceUpdate();
      },

      experiance() {
        var experiance = [];
        this.experiance_list
          .filter(function(item) {
            return item.selected;
          })
          .forEach((element) => {
            experiance.push(element.id);
          });
        return experiance;
      },
      ageGroups() {
        var age_groups = [];
        this.age_group_list
          .filter(function(item) {
            return item.selected;
          })
          .forEach((element) => {
            age_groups.push(element.id);
          });

        return age_groups;
      },
      skills() {
        var skills = [];
        this.skill_list
          .filter(function(item) {
            return item.selected;
          })
          .forEach((element) => {
            skills.push(element.id);
          });
        return skills;
      },
      tags() {
        var tags = [];
        this.tag_list
          .filter(function(item) {
            return item.selected;
          })
          .forEach((element) => {
            tags.push(element.id);
          });
        return tags;
      },
      occupations() {
        var occupation = [];
        this.occupation_list
          .filter(function(item) {
            return item.selected;
          })
          .forEach((element) => {
            occupation.push(element.id);
          });
        return occupation;
      },
      certification() {
        var certification = [];
        this.certification_list
          .filter(function(item) {
            return item.selected;
          })
          .forEach((element) => {
            certification.push(element.id);
          });
        return certification;
      },
      schoolTypes() {
        var school_type = [];
        this.school_type_list
          .filter(function(item) {
            return item.selected;
          })
          .forEach((element) => {
            school_type.push(element.id);
          });
        return school_type;
      },

      setUserProperties() {
        let userProperties = {};

        if (this.isProfessional) {
          userProperties["experience"] = this.experiance_list.filter(function(
            item
          ) {
            return item.selected;
          })[0].name;

          userProperties["occupations"] = this.occupation_list.filter(function(
            item
          ) {
            return item.selected;
          })[0].name;

          userProperties["certification"] = this.certification_list
            .filter(function(item) {
              return item.selected;
            })
            .map((item) => item.name);
        } else {
          userProperties["school type"] = this.school_type_list.filter(function(
            item
          ) {
            return item.selected;
          })[0].name;
        }

        userProperties["age groups"] = this.age_group_list
          .filter(function(item) {
            return item.selected;
          })
          .map((item) => item.name);

        userProperties["skills"] = this.skill_list
          .filter(function(item) {
            return item.selected;
          })
          .map((item) => item.name);

        userProperties["tags"] = this.tag_list
          .filter(function(item) {
            return item.selected;
          })
          .map((item) => item.name);

        userProperties["is professional"] = this.isProfessional ? "yes" : "no";

        AmplitudeHelper.setUserProperty(userProperties);
      },

      submitPreferences() {
        if (
          this.isProfessional
            ? this.validatePrefessionalPreferences()
            : this.validateParentPreferences()
        ) {
          var self = this;
          self.loadingSubmit = true;
          const successHandler = (res) => {
            self.loadingSubmit = false;
            console.log(res);

            self.setUserProperties();

            self.$store.dispatch("snackBar/showToast", {
              message: "Your Preferences are update!!",
              color: "S",
            });
            this.$router.push({
              name: ROUTER_URL.publicUser.children.myMembership.name,
            });
          };

          const failureHandler = (res) => {
            console.log(res);
            self.loadingSubmit = false;
          };

          let params = {};

          if (this.isProfessional) {
            params["experience"] = this.experiance();
            params["occupation"] = this.occupations();
            params["certification"] = this.certification();
          } else {
            params["school_type"] = this.schoolTypes();
          }

          params["age_groups"] = this.ageGroups();
          params["skills"] = this.skills();
          params["tags"] = this.tags();
          params["is_professional"] = this.isProfessional;

          Axios.request_POST(
            API_COMMON_URL.userPreferences,
            params,
            {},
            successHandler,
            failureHandler,
            false
          );
        }
      },
      validatePrefessionalPreferences() {
        var flagValid = true;
        var message = "";
        if (this.experiance().length != 1) {
          message = "Tell us how many years for experience you have";
          flagValid = false;
        } else if (this.ageGroups().length == 0) {
          message = "Select age groups you are intrested in";
          flagValid = false;
        } else if (this.skills().length == 0) {
          message = "Select skills you are intrested in";
          flagValid = false;
        } else if (this.tags().length == 0) {
          message = "Select tags you are intrested in";
          flagValid = false;
        } else if (this.occupations().length == 0) {
          message = "Select you work settings";
          flagValid = false;
        } else if (this.certification().length == 0) {
          message = "Select you certifications";
          flagValid = false;
        }

        if (!flagValid) {
          this.$store.dispatch("snackBar/showToast", {
            message: message,
            color: "W",
          });
        }

        return flagValid;
      },
      validateParentPreferences() {
        var flagValid = true;
        var message = "";
        if (this.ageGroups().length == 0) {
          message = "Select age groups you are intrested in";
          flagValid = false;
        } else if (this.skills().length == 0) {
          message = "Select skills you are intrested in";
          flagValid = false;
        } else if (this.tags().length == 0) {
          message = "Select tags you are intrested in";
          flagValid = false;
        } else if (this.schoolTypes().length == 0) {
          message = "Select type of school your child studies in";
          flagValid = false;
        }

        if (!flagValid) {
          this.$store.dispatch("snackBar/showToast", {
            message: message,
            color: "W",
          });
        }

        return flagValid;
      },
    },
    mounted() {},
  };
</script>

<style scoped>
  .heading {
    font-weight: 900;
    font-size: 24px;
    line-height: 36px;
    color: #333333;
    text-align: center;
  }
  .sub-heading {
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: rgba(51, 51, 51, 0.87);
  }
  .toggle-heading {
    font-weight: 900;
    font-size: 24px;
    line-height: 36px;
    color: #333333;
  }

  .toggle-text {
    font-weight: 900;
    font-size: 24px;
    line-height: 36px;
    color: #333333;
  }

  .preferences {
    max-width: 600px;
  }

  .preference-heading {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #333333;
  }

  .option {
    background: #ffffff;
    border: 1px solid rgba(51, 51, 51, 0.15);
    border-radius: 4px;
    cursor: pointer;
  }

  .option-active {
    background: #eaf1ff;
    border: 1px solid #506cff;
    border-radius: 4px;
    color: #506cff;
    cursor: pointer;
  }

  .btn-text {
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
    max-width: 570px;
  }
</style>
